import { ICollection } from "services/types";
import { IAppAction } from "../appAction";
import { collectionsActions } from "./collections-action";
import { getDefaultCollectionsState, ICollectionState } from "./collections-state";

const handlers = {
  [collectionsActions.FETCH_MY_COLLECTIONS]: (
    state: ICollectionState
  ): ICollectionState => {
    return { ...state, loading: true };
  },

  [collectionsActions.FETCH_COLLECTIONS_SUCCESS]: (
    state: ICollectionState,
    payload: ICollection[],
  ): ICollectionState => {
    return { ...state, collections: [...state.collections, ...payload], loading: false };
  },

  [collectionsActions.FETCH_COLLECTIONS_ERROR]: (
    state: ICollectionState,
    payload: Error
  ): ICollectionState => {
    return { ...state, loading: false, error: payload };
  },

  [collectionsActions.SET_TOTAL_COLLECTIONS]: (
    state: ICollectionState,
    payload: number
  ): ICollectionState => {
    return { ...state, total: payload };
  },

  [collectionsActions.SET_COLLECTIONS_EMPTY]: (
    state: ICollectionState
  ): ICollectionState => {
    return { ...state, collections: [] };
  },

  [collectionsActions.FETCH_MY_CURRENT_COLLECTION]: (
    state: ICollectionState
  ): ICollectionState => {
    return { ...state, loading: true };
  },

  [collectionsActions.FETCH_CURRENT_COLLECTION_SUCCESS]: (
    state: ICollectionState,
    payload: ICollection
  ): ICollectionState => {
    return { ...state, currentCollection: payload, loading: false };
  },

  [collectionsActions.FETCH_CURRENT_COLLECTION_ERROR]: (
    state: ICollectionState,
    payload: Error
  ): ICollectionState => {
    return { ...state, error: payload, loading: false };
  },

  [collectionsActions.SET_COLLECTIONS_OWNER_NAME]: (
    state: ICollectionState,
    payload: any
  ): ICollectionState => {
    return { ...state, collectionsOwnerName: payload };
  },

  [collectionsActions.CREATE_COLLECTION]: (
    state: ICollectionState
  ): ICollectionState => {
    return { ...state, loading: true };
  },

  [collectionsActions.CREATE_COLLECTION_SUCCESS]: (
    state: ICollectionState,
  ): ICollectionState => {
    return { ...state, loading: false, error: null };
  },

  [collectionsActions.CREATE_COLLECTION_ERROR]: (
    state: ICollectionState,
    payload: Error
  ): ICollectionState => {
    return { ...state, loading: false, error: payload };
  },

  [collectionsActions.EDIT_COLLECTION]: (
    state: ICollectionState
  ): ICollectionState => {
    return { ...state, loading: true };
  },

  [collectionsActions.EDIT_COLLECTION_SUCCESS]: (
    state: ICollectionState,
  ): ICollectionState => {
    return { ...state, loading: false, error: null };
  },

  [collectionsActions.EDIT_COLLECTION_ERROR]: (
    state: ICollectionState,
    payload: Error
  ): ICollectionState => {
    return { ...state, loading: false, error: payload };
  },

  [collectionsActions.ADD_GIF_TO_COLLECTION]: (
    state: ICollectionState
  ): ICollectionState => {
    return { ...state, loading: true };
  },

  [collectionsActions.ADD_GIF_TO_COLLECTION_SUCCESS]: (
    state: ICollectionState
  ): ICollectionState => {
    return { ...state, loading: false, error: null };
  },

  [collectionsActions.ADD_GIF_TO_COLLECTION_ERROR]: (
    state: ICollectionState,
    error: Error
  ): ICollectionState => {
    return { ...state, loading: false, error: error };
  },

  [collectionsActions.SET_NEW_COLLECTION_ID]: (
    state: ICollectionState,
    newCollectionId: any
  ): ICollectionState => {
    return { ...state, newCollectionId: newCollectionId };
  }
};

export const collectionsReducer = (
  state: ICollectionState = getDefaultCollectionsState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) : state;
};
